import React from "react";
import { Helmet } from "react-helmet";
// import img1 from "../../../assets/islam/img-title/กฎหมายมรดก.png";
import Ex1 from "../../../components/islam/posts-islam/Img_Islam/Ex1.png"
import Ex2 from "../../../components/islam/posts-islam/Img_Islam/Ex2.png"
import "./posts-islam.css"

const กรณีพิเศษ = () => {
  const TITLE = "การแบ่งมรดกกรณีพิเศษ";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <br></br>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; การแบ่งมรดกกรณีพิเศษ ทางผู้จัดทำได้แบ่งออกเป็น 9 หัวข้อ ตามแหล่งอ้างอิงที่ได้ศึกษาไว้ ดังต่อไปนี้
        </p>

        {/* มรดกซ้อน */}
        <div>
          <h2 id="initial-header">1. การแบ่งมรดกซ้อน (المناسخات) </h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การแบ่งมรดกซ้อน หมายถึง วิธีการแบ่งมรดกของผู้ตายในกรณีที่มีการเสียชีวิตเกิดขึ้นซ้อนกัน โดยยังไม่ได้แบ่งมรดกของผู้ตายคนแรกแล้วเกิดเหตุการณ์มีผู้เสียชีวิตเกิดขึ้นในครั้งที่สอง 
            ซึ่งผู้ตายคนแรกและคนที่สอง (หรือหลายคน) นั้นเป็นทายาทซึ่งกันและกัน ซึ่งปัญหาการแบ่งมรดกซ้อนมีอยู่ 2 ลักษณะ
            <p className="ml-4">
              <ul className=" list-decimal ml-8 mb-3">
                <li><b>ทายาทผู้รับมรดกมีสิทธิรับมรดกทั้งผู้ตายคนแรกและคนที่สอง</b> โดยไม่มีการเปลี่ยนแปลงใด ๆ ไม่ว่าจะเป็นทั้งช่องทางการสืบมรดก หรือวิธีการรับมรดกของเขา
                  ในกรณีนี้ให้จัดการแบ่งมรดกของผู้ตายทั้งสองแก่ทายาทโดยให้ถือเสมือนว่าผู้ตายคนที่สองไม่มีตั้งแต่แรก แบ่งเฉพาะทายาทที่มีชีวิตอยู่เท่านั้น ซึ่งทำการแบ่งมรดกแค่ครั้งเดียว 
                  <p className="ml-8">
                    <span className=" text-blue-600">
                      -- เช่น นาย ก. ได้เสียชีวิต โดยนาย ก. มีบุตรชาย 4 คน และบุตรหญิง 2 คน หลังจากนั้นยังไม่ทันได้แบ่งมรดก บุตรชายของนาย ก. คนหนึ่งได้เสียชีวิตลงไปอีกคนโดยไม่มีทายาท (ไม่มีทั้งภรรยาและบุตร) เลย เว้นแต่พี่น้องชายและพี่น้องหญิงของเขาเท่านั้น
                      ในกรณีอย่างนี้สามารถแบ่งมรดกให้แก่พี่น้องชายและพี่น้องหญิงได้ภายในครั้งเดียว เสมือนว่าผู้ตายคนที่ 2 ไม่มีอยู่ตั้งแต่แรก เพราะไม่มีผลที่ทำให้โครงสร้างของทายาทในกลุ่มที่เหลือมีการเปลี่ยนแปลง
                    </span>
                  </p>
                </li>
                <li><b>ทายาทผู้รับมรดกมีสิทธิรับมรดกของผู้ตายคนที่สองแต่ไม่ได้มีสิทธิรับมรดกของผู้ตายคนแรก</b> หรือโครงสร้างของทายาทมีการเปลี่ยนเนื่องจากผู้ตายคนที่สองเป็นสาเหตุ สำหรับกรณีนี้ให้จัดาการแบ่งมรดกของผู้ตายคนที่ 1 ให้แก่ทายาทของเขาก่อน
                  หลังจากนั้นให้จัดการแบ่งมรดกของผู้ตายคนที่ 2 ให้แก่ทายาทของเขาตามลำดับ
                  <p className="ml-8">
                    <span className=" text-blue-600">
                      -- เช่น นาย ก. ได้เสียชีวิต โดยนาย ก. มีบุตรชาย 1 คน บุตรหญิง 2 คน หลานชาย มารดา และบิดา พร้อมกับมรดกเป็นเงินจำนวน 180,000 บาท แต่ก่อนที่จะจัดการแบ่งมรดกให้แก่ทายาทของเขา บุตรชายของเขาเกิดอุบัติเหตุทำให้เสียชีวิต โดยที่บุตรชาย (ผู้ตายคนที่ 2) หรือนาย ข.
                      มีมรดกที่เป็นจำนวนเงิน 500,000 บาท ซึ่งนาย ข. มีบุตรชาย 1 คน ภรรยา 1 คน น้องสาวร่วมบิดามารดา 2 คน ปู่ และย่า ทำให้มีการเกิดการแบ่งมรดก 2 ครั้ง ดังนี้
                    </span>
                    <p className="ml-2"><br></br>
                      <a className="text underline"><mark className=" bg-[#fee9b2] rounded-xl">การแบ่งมรดกครั้งที่ 1 (นาย ก.)</mark>{" "}</a>{" "} 
                      <img
                        src={Ex1}
                        alt="Ex1"
                        className="w-11/12 block ml-auto mr-auto mt-3"
                      />
                      <br></br>
                      <span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เมื่อนำสัดส่วนที่ได้รับของทายาทแต่ละคน มาคูนด้วยจำนวณเงินมรดกที่ นาย ก. ทิ้งไว้ ทำให้ทายาทแต่ละคนได้ส่วนแบ่งจากกองมรดกดังนี้ 
                        <ul className=" list-disc ml-16 mt-3">
                          <li>บิดา ได้รับเงินเป็นจำนวณ (1/6) * 180,000 = 30,000 บาท</li>
                          <li>มารดา ได้รับเงินเป็นจำนวณ (1/6) * 180,000 = 30,000 บาท</li>
                          <li>บุตรชาย (นาย ข .) ได้รับเงินเป็นจำนวณ (1/3) * 180,000 = 60,000 บาท</li>
                          <li>บุตรสาว 2 คนได้รับเงินเป็นจำนวณ (1/3) * 180,000 = 60,000 บาท <span className=" text-red-600">โดยแบ่งให้คนละ 30,000 บาท</span></li>
                          <li>หลานชาย ไม่ได้รับมรดกเนื่องจากถูกกันสิทธิโดยบุตรชายของนายก. </li>
                        </ul>{" "}
                      </span>
                      <br></br>
                      <a className="text underline"><mark className=" bg-[#fee9b2] rounded-xl">การแบ่งมรดกครั้งที่ 2 (นาย ข.)</mark>{" "}</a>{" "} 
                      <img
                        src={Ex2}
                        alt="Ex2"
                        className="w-11/12 block ml-auto mr-auto mt-3"
                      />
                      <br></br>
                      <span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;นาย ข. มีทรัพย์มรดกเป็นจำนวนเงิน 500,000 บาท และนอกจากนี้นาย ข. ยังได้รับเงินมรดกจากบิดาในการแบ่งทรัพย์สินครั้งที่ 1 เป็นจำนวนเงิน 60,000 บาท ทำให้นาย ข.มีทรัพย์มรดกเป็นจำนวนเงิน 560,000 บาท 
                        โดยเมื่อนำสัดส่วนที่ได้รับของทายาทแต่ละคน มาคูนด้วยจำนวณทรัพย์มรดกที่ นาย ข. ทิ้งไว้ ทำให้ทายาทแต่ละคนได้ส่วนแบ่งจากกองมรดกดังนี้ 
                        <ul className=" list-disc ml-16 mt-3">
                          <li>ปู่ ได้รับเงินเป็นจำนวณ (1/6) * 560,000 = 108,333.3 บาท</li>
                          <li>ย่า ได้รับเงินเป็นจำนวณ (1/6) * 560,000 = 108,333.3 บาท</li>
                          <li>ภรรยา ได้รับเงินเป็นจำนวณ (1/8) * 560,000 = 81250 บาท</li>
                          <li>บุตรชาย ได้รับเงินเป็นจำนวณ (13/24) * 560,000 = 352083.3 บาท</li>
                          <li>น้องสาว 2 คน ไม่ได้รับมรดกเนื่องจากถูกกันสิทธิโดยหลานชาย (บุตรชายของนาย ข.)</li>
                        </ul>{" "}
                      </span>
                    </p>
                  </p>
                </li>
              </ul>{" "}
            </p> 
          </p>
        </div>{/* มรดกซ้อน */}

        {/* 2. การยินยอมในการแบ่งมรดก */}
        <div>
          <h2 id="second-header">2. การยินยอมในการแบ่งมรดก (التخارج) </h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การยินยอมกันในการแบ่งมรดก หมายถึง การที่ทายาทของผู้ตายได้มีมติในการหาทางออกร่วมกันในการแบ่งมรดก โดยหวังความสะดวกสบาย และเกิดประโยชน์สูงสุดแก่ทายาททุกคนร่วมกัน
            ซึ่งการยินยอมกันในการแบ่งมรดกเป็นสิ่งที่อนุมัติในกฎหมายมรดกอิสลาม และยังถือเป็นเรื่องที่ดีที่สมควรที่จะทำในหมู่ทายาทของผู้ตาย เพราะโดยในสภาพความเป็นจริงผู้ตายมักจะทิ้งทรัพย์สินที่ไม่ใช่จำนวนเงินอย่างเดียว 
            เช่น  ที่ดิน ทอง ที่อยู่อาศัย รถ หรืออื่น ๆ ซึ่งหากต้องการขายทรัพย์สินดังกล่าวในระยะเวลาที่กระชั้นชิด จะส่งผลให้ราคาทรัพย์สินนั้นต่ำกว่าท้องตลาด โดยจะส่งผลให้ทายาททุกรายได้รับส่วนแบ่งที่ต่ำลงโดยปริยาย 
            ซึ่งหากทุกฝ่ายได้หาทางออกร่วมกันอาจนำทรัพย์สินเหล่านั้นแบ่งตามความต้องการ (สูงสุด) ของแต่ละคน แน่นอนว่ามูลค่าของมรดกที่ผู้ตายได้ทิ้งไว้ให้แก่ทายาทนั้นไม่เสียราคาแม้แต่น้อย และยังสร้างความอบอุ่น ความสามัคคีให้เกิดขึ้นในหมู่ทายาทอีกด้วย
              <p>
                <br></br>
                <a className="text underline ml-8 text-red-600" ><b>ข้อจำกัดในการยอมกันในการแบ่งมรดก</b></a>{" "}
                <p className="ml-8">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การหาทางออกร่วมกันในการแบ่งมรดกใช้ได้กับทุกกรณี ถ้าหากว่าบรรดาทายาทของผู้ตายมีประสงค์ <mark className=" bg-[#fee9b2] rounded-xl">ยกเว้นในกรณีที่ทายาทผู้ตายบางคนอยู่ในสภาพที่ไม่สามารถรับรู้ ไม่สามารถตัดสินใจด้วยตัวเองได้ ไม่เอื้อต่อการเสนอแนะ หรือแสดงความคิดเห็น</mark>{" "}
                  เช่น เด็กเล็ก คนวิกลจริต หรือผู้สูงอายุที่ไม่สามารถรับรู้ข้อตกลง หรือมติในที่ประชุมได้เลย <mark className=" bg-[#fee9b2] rounded-xl">หากเป็นเช่นนี้ไม่อนุญาตให้ใช้วิธีการยินยอมในการแบ่งมรดกเพื่อหาทางออกร่วมกัน</mark>{" "} <a className="text underline"><b>เว้นแต่ว่าบุคคลดังกล่าวจะได้รับสิทธิเพิ่มขึ้น หรือเท่าเดิม โดยไม่ได้ถูกลิดรอนสิทธิแม้แต่น้อย 
                  ซึ่งในการนี้สามารถใช้วิธีการยินยอมในการแบ่งมรดกกันได้</b></a>{" "} เพื่อประโยชน์ร่วมกันที่สามารถรักษามูลค่าของทรัพย์มรดกให้เกิดประโยชน์สูงสุด
                </p>
              </p>
          </p>
        </div>{/* 2. การยินยอมในการแบ่งมรดก */}

        {/* คนสูญหาย */}
        <div>
          <h2 id="third-header">3. การแบ่งและการรับมรดกของผู้ที่หายสาบสูญ (ميراث المفقود) </h2>
          <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;อัลมัฟกูด (المفقود) หมายถึง บุคคลที่หายตัว หรือหายสาบสูญไปจากถิ่นที่อยู่เป็นเวลานาน ขาดการติดต่อ ไม่ทราบสภาพความเป็นอยู่ของเขาว่ายังมีชีวิตอยู่ หรือเสียชีวิตไปแล้ว
          <a className="text underline ml-1"><b>ซึ่งประเด็นที่เกี่ยวข้องของผู้ที่สาบสูญในกฎหมายอิสลาม (วิชาฟิกฮฺ) มีดังนี้</b></a>{" "}
            <ul className=" list-decimal ml-16 mb-3 mt-2">
              <li><b>ในด้านความสัมพันธ์ระหว่างตัวเขากับภริยา</b>
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                ในกฎหมายอิสลามถือว่าผู้ที่หายสาบสูญยังมีความสัมพันธ์ฉันท์สามีภรรยากันตามปกติ และทั้งสองยังมีสิทธิรับมรดกซึ่งกันและกัน ภรรยาของผู้ที่หายสาบสูญยังไม่สามารถแต่งงานใหม่ได้ จนกว่าจะมั่นใจว่าผู้ที่หายสาบสูญนั้นได้เสียชีวิตลงไปแล้ว
                เพราะถือหลักที่ว่าช่วงเวลาที่ผู้หายสาบสูญหายตัวไปเขายังมีชีวิตอยู่ ซึ่งจะเปลี่ยนสภาพของผู้ที่หายสาบสูญไปไม่ได้ จนกว่าจะมีความมั่นใจว่าเขาได้เสียชีวิตในระหว่างการสูญหาย
              </li>
              <li><b>เกี่ยวกับทรัพย์สินของเขาที่เป็นมรดกตกทอดไปยังผู้อื่น</b>
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                สำหรับทรัพย์สินของบุคคลที่หายสาบสูญ ไม่ว่าจะเป็นทรัพย์สินที่ผู้สูญหายมีอยู่ก่อนแล้ว หรือเป็นทรัพย์สินที่เกิดขึ้นระหว่างที่หายสาบสูญไป ให้อายัดทรัพย์สิน ห้ามดำเนินการใด ๆ ในตัวทรัพย์สิน จนกว่าจะมีความชัดเจน หรือศาลพิพากษา หรือมีคำสั่งว่าผู้ที่หายสาบสูญนั้นได้เสียชีวิตลงไปแล้ว
              </li>
              <li><b>เกี่ยวกับการรับมรดกจากผู้อื่น</b>
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                ในกรณีนี้หมายถึงผู้ที่หายสาบสูญเป็นทายาทที่ได้รับมรดกจากผู้ที่เสียชีวิตไปในขณะที่ตัวเขาได้หายสาบสูญ ซึ่งในประเด็นนี้ให้ถือว่าผู้ที่หายสาบสูญนั้นยังมีชีวิตอยู่ ตราบใดที่ยังไม่มีหลักฐานที่แน่ชัดว่าผู้ที่หายสาบสูญเสียชีวิตไปแล้ว หรือตราบใดที่ศาลยังมิได้พิพากษา หรือมีคำสั่งว่าได้เสียชีวิตไปแล้ว ภายหลังผ่านพ้นช่วงระยะเวลาหนึ่งที่ค่อนข้างแน่ใจแล้วว่าผู้สาบสูญได้เสียชีวิตไปแล้ว
                <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ส่วนผู้สาบสูญที่เป็นทายาทผู้รับมรดก และมีทายาทบุคคลอื่น ๆ ร่วมรับมรดกด้วยแล้ว ทายาทบุคลอื่น ๆ จะมี 3 สภาพด้วยกัน
                  <ul className=" list-disc ml-16 mb-3 mt-2">
                    <li><b>สภาพที่ 1</b> ทายาทผู้อื่นไม่ได้รับผลกระทบต่อการรับมรดกของเขาในกรณีมีผู้ที่หายสาบสูญ หรือไม่มีผู้ที่หายสาบสูญ
                      <br></br>
                      <p className="ml-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;วิธีการจัดการ: ให้ทายาทผู้อื่นได้รับส่วนแบ่งของเขาอย่างครบถ้วน โดยไม่ต้องรอผู้ที่หายสาบสูญ
                        <p className="ml-8">
                          <span className=" text-blue-600">
                            -- เช่น  ผู้ตายมีภรรยา 1 คน และบุตรชาย 2 คน (แต่หายสาบสูญไปคนหนึ่ง) ในกรณีนี้ทายาทจะได้รับส่วนแบ่งดังนี้
                            <ul className=" list-disc ml-16 mb-3 mt-2">
                              <li>ภรรยา ได้รับ 1/8 จากกองมรดก</li> 
                              <li>บุตรชาย ได้รับส่วนเหลือ <span className=" text-red-600">โดยให้บุตรชายที่ยังอยู่รับส่วนที่ 1/2 ของส่วนเหลือ อีกครึ่งเก็บไว้ให้บุตรชายที่หายสาบสูญ</span> <a className="text-indigo underline">หากมีความแน่ชัดว่าบุตรชายที่ได้หายสาบสูญนั้นเสียชีวิตลงแล้ว จึงมอบส่วนที่ได้เก็บไว้ให้แก่บุตรชายที่ยังมีชีวิตอยู่ เนื่องจากว่าเขาได้รับส่วนเหลือเพียงคนเดียว</a>{" "}</li>
                            </ul>
                          </span>
                        </p>
                      </p>
                    </li>
                    <li><b>สภาพที่ 2</b> ทายาทผู้อื่นจะได้รับผลกระทบในบางกรณี และจะไม่ได้รับผลกระทบในบางกรณี
                      <br></br>
                      <p className="ml-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;วิธีการจัดการ: ทายาทผู้อื่นจะไม่ได้รับส่วนแบ่งจนกว่าจะมีความชัดเจนในเรื่องของผู้ที่หายสาบสูญ หรือมีการตัดสินของศาลว่าเขาได้เสียชีวิตแล้ว</p>
                      <p className="ml-8">
                          <span className=" text-blue-600">
                            -- เช่น  ผู้ตายมีลุง และบุตรชาย 1 คน แต่ปรากฏว่าหายสาบสูญ  ในกรณีนี้ทายาทจะได้รับส่วนแบ่งดังนี้
                            <ul className=" list-disc ml-16 mb-3 mt-2">
                              <li>ลุง จะไม่ได้รับมรดก เนื่องจากตัวเขานั้นถูกกันสิทธิไม่ให้ได้รับมรดกโดยบุตรชายของผู้ตาย หากบุตรชายของผู้ตายนั้นยังไม่มีการยืนยันว่าเสียชีวิต แต่หากมีการยืนยันว่าบุตรชายของผู้ตายที่หายสาบสูญนั้นเสียชีวิตลงแล้ว ลุงจะได้รับมรดกทั้งหมด เนื่องจากลุงเป็นทายาทคนเดียวที่เหลืออยู่ของผู้ตาย</li> 
                            </ul>
                          </span>
                        </p>
                    </li>
                    <li><b>สภาพที่ 3</b> ทายาทผู้อื่นจะได้รับมรดกได้ทั้งสองกรณี แต่ส่วนได้ไม่เท่ากันใน 2 กรณี
                      <br></br>
                      <p className="ml-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;วิธีการจัดการ: ให้ขอร้องทายาทผู้อื่นให้รอคอยความชัดเจนของผู้ที่หายสาบสูญ หรือการตัดสินของศาล หากไม่ได้รับความยินยอมก็ให้เขารับส่วนแบ่งในกรณีที่ได้รับน้อยที่สุด</p>
                    </li>
                  </ul>
              </li>
            </ul>
          </p>
        </div>{/* คนสูญหาย */}

        {/* บุตรนอกสมรส */}
        <div>
          <h2 id="fourth-header">4. การรับมรดกของบุตรนอกสมรส (زنا)</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;นักวิชาการเห็นพ้องต้องกันว่า เด็กที่กิดจากการละเมิดประเวณี (زنا) นั้น จะสืบสกุลจากฝ่ายมารดาของตนเท่านั้น จะไม่สืบสกุลจากฝ่ายบิดาของตนที่เป็นผู้ละเมิดประเวณี เพราะการสืบสกุลของตนจากฝ่ายบิดานั้นยังไม่อาจเชื่อถือได้อย่างเด็ดขาดแน่นอน เพราะศาสนาไม่ถือว่าการละเมิดประเวณี 
            เป็นการมีความสัมพันธ์ระหว่างชายหญิงที่ถูกต้อง และไม่ถือว่าสืบสกุลระหว่างกัน ดังนั้นจึงไม่มีการรับมรดกระหว่างกัน และระหว่างบุตรที่เกิดจากการละเมิดประเวณีกับบิดาของผู้ละเมิดประเวณี และญาติทางฝ่ายบิดาของเขา แต่บุตรที่เกิดจากการละเมิดประเวณีสามารถรับมรดของมารดา และญาติฝ่ายมารดาได้ และญาติฝ่ายมารดาก็มีสิทธิรับมรดกของบุตรที่เกิดจากการประเวณีได้เช่นเดียวกัน
            เพราะความสัมพันธ์ระหว่างเขากับมารดาเป็นสิ่งที่เชื่อถือได้เด็ดขาดแน่นอน ความเป็นมารดาแม้จะไม่ถูกต้องตามหลักศาสนา ก็ก่อให้เกิดความสัมพันธ์ระหว่างมารดากับบุตรขึ้น ซึ่งนำไปสู่การรับมรดกระหว่างกัน
          </p>
        </div>{/* บุตรนอกสมรส */}

        {/* บุตรที่แม่ถูกปรักปรำ */}
        <div>
          <h2 id="fifth-header">5. การรับมรดกของเด็กที่แม่ถูกปรักปรำว่าละเมิดประเวณี</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เมื่อเกิดเหตุการณ์ที่สามีได้ปรักปรำภรรยาของเขาว่าได้ละเมิดประเวณี และไม่ยอมรับว่าเด็กที่เกิดจากภรรยาเป็นลูกของเขา ซึ่งหากมีการปรับปรำเกิดขึ้นกอฎี หรือศาลตัดสินพิพากษาให้ทั้งคู่แยกจากการเป็นสามีภรรยา สามีก็ไม่ต้องยอมรับว่าเด็กที่เกิดมานั้นเป็นบุตรของเขา เพราะฉะนั้นเด็กที่เกิดจากผู้หญิงที่ถูกปรักปรำว่าละเมิดประเวณี จะไม่มีสิทธิในการรับมรดกของบิดา และญาติของบิดา แต่ให้สืบมรดกจากฝ่ายมารดา 
            และญาติฝ่ายมารดาเท่านั้น เพราะหลักศาสนาอิสลามถือว่าระหว่างเด็กกับพ่อของเด็กจะไม่เกี่ยวพันกันในทางสายเลือด 
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ซึ่งกฎหมายการที่สามีกล่าวหาว่าภรรยาละเมิดประเวณีนั้นมีรายละเอียดที่ยิบย่อย จะต้องปรักปรำให้ถูกต้องตาหลักศาสนาบัญญัติ ซึ่งหากสามีนั้นได้ปรักปรำภรรยาว่าละเมิดประเวณีตามบัญญัติศาสนาแล้ว แต่หากไม่มีพยานบุคคล 4 คนมายืนยัน ผู้เป็นสามีจะถูกเฆี่ยนตี 80 ครั้ง และภรรยาของเขาจะบริสุทธิ์จาการที่ถูกปรัปรำ 
            ซึ่งภรรยาของเขาก็จะต้องกล่าวว่าสามีของเขานั้นพูดเท็จโดยจะต้องเป็นไปตามบทบัญญัติของศาสนาเช่นเดียวกัน 
          </p>
        </div>{/* บุตรที่แม่ถูกปรักปรำ */}

        {/* ทารกในครรภ์ */}
        <div>
          <h2 id="sixth-header">6. การรับมรดกของทารกในครรภ์</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;สำหรับการแบ่งมรดกให้กับทารกที่ยังอยู่ในครรภ์มารดานั้น หากเป็นความประสงค์ของผู้รับมรดกคนอื่น ๆ ทั้งหมดที่ไม่รีบร้อนในการรับมรดกก็ให้ประวิงเวลาในการแบ่งมรดกไว้จนกว่าทารกนั้นจะคลอดออกมาเพื่อความชัดเจนในการระบุเพศ และการกำหนดสิทธิในการรับมรดกของทารกดังกล่าว 
            แต่ถ้าหากผู้รับมรดกคนอื่น ๆ มีความต้องการที่จะรีบรับมรดกก็สามารถที่จะจัดการแบ่งมรดกตามสิทธิที่ทารกในครรภ์ได้รับไม่ว่าจะเป็นผู้ชาย หรือผู้หญิงได้ทันทีโดยจะต้องใช้วิธีการเฉพาะ คือ ให้ปฏิบัติต่อทายาทอื่น ๆ ด้วยการให้ได้รับส่วนแบ่งที่น้อยที่สุด โดยการสมมุติรูปแบบต่าง ๆ ของการมี และไม่มีทารกในครรภ์มารดา มีชีวิตอยู่ หรือเสียชีวิต 
            เป็นเพศชาย หรือเพศหญิง มีคนเดียว หรือหลายคน และให้ทายาททุกคนได้รับส่วนแบ่งของแต่ละคนที่มั่นใจได้ว่าไม่มีการผิดพลาด และให้อายัดส่วนที่เหลือไว้จนกว่าจะปรากฏสภาพที่แท้จริงของทารกในครรภ์มารดา
            <p className="ml-8">
              <span className=" text-blue-600">
                -- เช่น  ผู้ตายได้ทิ้งภรรยามีครรภ์ไว้ โดยให้สมมุติและแบ่งดังนี้
                <ul className=" list-disc ml-16 mb-3 mt-2">
                  <li><b>ทารกคลอดแต่เสียชีวิต</b> ภรรยาจะได้รับ 1/4 จากกองมรดก</li>
                  <li><b>ทารกคลอดและยังมีชีวิต ไม่ว่าจะเป็นเพศหญิง หรือเพศชาย หนึ่งคน หรือหลายคน</b> ภรรยาจะได้รับ 1/8 จากกองมรดก</li> 
                </ul>
                ดังนั้นให้ภรรยาได้รับ 1/8 เพราะเป็นส่วนแบ่งที่มั่นใจได้ว่าจะไม่ผิดพลาด และให้อายัดมรดกที่เหลือไว้ก่อน จนกว่าจะปรากฏสภาพที่แท้จริงของทารกในครรภ์ ซึ่งนำเอามรดกที่ถูกอายัดไว้แบ่งได้ดังนี้
                <ul className=" list-disc ml-16 mb-3 mt-2">
                  <li><b>ทารกเพศชาย</b> ได้รับมรดกทั้งหมดจากการมรดกที่ถูกอายัดไว้</li>
                  <li><b>ทารกเพศหญิง</b> ได้รับ 1/2 ของกองมรดกที่ถูกอายัดไว้ และส่วนที่เหลือจาก 1/2 ถ้าหากไม่มีบัยตุลมาล แต่ถ้าหากมีบัยตุลมาลที่มีการจัดเก็บที่ดี ส่วนที่เหลือจาก 1/2 ก็ให้ขึ้นกับบัยตุลมาล ซึ่งจะต้องภายหลังจากการแบ่งมรดกให้แก่ภรรยา และทารกเพศหญิงที่คลอดแล้วเท่านั้น</li> 
                </ul>              
              </span>
            </p>
          </p>
        </div>{/* ทารกในครรภ์ */}

        {/* การรับมรดกของกะเทย */}
        <div>
          <h2 id="seventh-header">7. กาารรับมรดกของกะเทย</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;กะเทย หรือคุนซา (الخنثى) ตามหลักภาษามาจากคำว่า อินคินาซ (انخناث) ซึ่งมีความหมายว่ากลายเป็นสอง และแตกออก โดยกะเทย หรือคุนซามี 2 ประเภท คือ
            <ul className=" list-decimal ml-12 mb-3 mt-2">
              <li><b>คุนซา มุชกิล (الخنثى المشكل) </b> 
              ตามหลักศาสนาหมายถึงบุคลลที่มีอวัยวะเพศชายและอวัยวะเพศหญิงในร่างเดียวกัน หรือไม่มีอวัยวะเพศใดบ่งบอกเพศอยู่เลย โดยคุนซามุชกิลนั้นจะไม่อยู่ในสภาพที่เป็นบิดา มารดา ปู่ ย่า และยาย เพราะถ้าหากว่าเขามีสภาพเป็นคนใดคนหนึ่งจากที่กล่าวมา เขาก็เป็นบุคคลที่มีเพศชัดเจนไม่เป็นเพศหญิงก็เป็นเพศชาย และเขาก็ไม่อยู่ในสภาพที่เป็นสามี
              สรรยา เพราะศาสนาอิสลามไม่ยินยอมให้เขาแต่งงานกัน ตราบใดที่ยังไม่ปรากฏเพศสภาพที่แน่นอนของเขา ดังนั้นในเรื่องการรับมรดกของกะเทย หรือคุนซามุชกิลจึงมาจากสี่ฝ่ายเท่านั้น คือ บุตร พี่น้อง ลุง และนายที่ปลดปล่อยทาส
              </li>
              <li><b>คุนซาไม่มุชกิล (الخنثى غير المشكل) </b>
                ตามหลักศาสนาหมายถึงบุคลลที่มีอวัยวะเพศชาย และอวัยวะเพศหญิงในร่างเดียวกัน หรือไม่มีอวัยวะเพศใดบ่งบอกเพศอยู่เลย
              </li>
                <p className=" mt-2">
                  <a className="text-indigo underline"><b>วิธีการแบ่งมรดกของกะเทย หรือคุนซา</b></a>{" "} 
                </p>
                <ul className=" list-decimal ml-8 mb-3 ">
                    <li>ในกรณีที่การแบ่งมรดกให้กะเทยมุชกิลมีผลที่ไม่แตกต่างกัน ทั้งตัวของกะเทยมุชกิลเอง หรือของบุคลลที่รับมรดกร่วมกับเขา ไม่ว่าจะสมมุติว่ากะเทยมุชกิลนั้นจะเป็นเพศใดก็ตาม ในกรณีนี้ให้แบ่งมรดกให้แก่ทุกคนได้เลย</li>
                    <li>ในกรณีที่กะเทยมุชกิลได้รับมรดก ถ้าหากสมมุติว่าเขาเป็นชาย หรือเป็นหญิง แต่จะไม่ได้รับมรดกหากสมมุติว่าเป็นอีกอย่างหนึ่ง ในกรณีนี้ให้ระงับการแบ่งมรดกให้แก่ทายาทที่เป็นกะเทยมุชกิล จนกว่าจะปรากฏชัดว่าเขาเป็นผู้ชาย หรือว่าเขาเป็นผู้หญิง</li>
                    <li>ในกรณีที่กะเทยมุชกิลได้รับส่วนแบ่งที่ต่างกัน ระหว่างการสมมุติทั้ง 2 ครั้ง (สมมุติว่าเป็นชาย 1 ครั้ง และสมมุติว่าเป็นหญิง 1 ครั้ง) และทายาทอื่น ๆ ก็เช่นเดียวกัน จะได้รับส่วนแบ่งที่แตกต่างกันออกไปตามที่ได้สมมุติทั้ง 2 ครั้ง ในกรณีนี้ให้แบ่งมรดกให้แก่กะเทยมุชกิล และทายาทคนอื่น ๆ ด้วยการให้ได้รับส่วนแบ่งที่น้อยที่สุด จากการสมมุติทั้ง 2 ครั้ง เพื่อเป็นการสะดวกในการจัดการต่อไปหากเกิดมีการเปลี่ยนแปลงจากสมมุติฐานในตอนแรก</li>
                </ul>
                <p className=" mt-2">
                  <a className="text-indigo underline"><b>ทัศนะของนักวิชาการสำหรับการรับมรดกของกะเทย มีดังนี้</b></a>{" "}
                  <ul className=" list-disc ml-8 mb-3 ">
                    <li><b>ท่านอิหม่าชาฟิอีย์ (เราะฮิมะฮุ้ลลอฮฺ)</b> มีความเห็นว่า ให้แบ่งทรัพย์สินให้บุคคลที่เป็นกะเทย และทายาทบุคคลอื่นเท่าส่วนที่ได้รับในกรณีที่น้อยที่สุด และส่วนที่เหลือให้กันเอาไว้จนกว่าจะปรากฏสภาพที่ชัดเจนของผู้ที่เป็นกะเทย หรือให้ทายาทตกลงกันเอง</li>
                    <li><b>ท่านอิหม่ามอะบูหะนีฟะฮฺ (เราะฮิมะฮุ้ลลอฮฺ)</b> มีความเห็นว่า ให้ส่วนแบ่งที่น้อยที่สุดกับกะเทยที่รับมรดกในฐานะเพศชาย และเพศหญิง และจะไม่ให้อะไรเลยหากการรับมรดกในฐานะเพศหนึ่งเพศใดถูกกันสิทธิ</li>
                    <li><b>ท่านอิหม่ามมาลิก(เราะฮิมะฮุ้ลลอฮฺ)</b> มีความเห็นว่า ให้แบ่งทรัพย์มรดกให้กะเทยครึ่งหนึ่งของส่วนได้ของเพศชายหากเขารับมรดกในฐานะเพศชายเพียงอย่างเดียว และครึ่งหนึ่งของเพศหญิงหากเขารับมรดกในฐานะเพศหญิงเพียงอย่างเดียว และแบ่งให้ครึ่งหนึ่งของส่วนได้ของเพศชาย และครึ่งหนึ่งของส่วนได้ของเพศหญิงหากเขารับมรดกทั้งสองฐานะ</li>
                    <li><b>ท่านอิหม่ามอะหฺมัด (เราะฮิมะฮุ้ลลอฮฺ)</b> มีความเห็นเช่นเดียวกับความเห็นของท่านอิหม่ามชาฟิอีหากกะเทยผู้นั้นมีโอกาสที่จะรู้เพศที่แท้จริงของเขา และมีความเห็นเหมือนกับท่านอิหม่ามมาลิกหากกะเทยผู้นั้นไม่มีโอกาสที่จะรู้เพศที่แท้จริงของเขาได้</li>
                </ul>
                </p>
            </ul>
          </p>
        </div>{/* การรับมรดกของกะเทย */}

        {/* ผู้ตายหมู่ */}
        <div>
          <h2 id="eigth-header">8. มรดกของผู้ตายหมู่</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ในกรณีที่มีบุคคลที่มีสิทธิรับมรดกซึ่งกันและกันได้ตั้งแต่สองคนขึ้นไปเสียชีวิตพร้อมกัน ไม่ว่าจะด้วยอุบัติเหตุที่เกิดขึ้นอย่างกะทันหัน เช่น เป็นลม จมน้ำ ไฟไหม้ หรืออื่น ๆ โดยไม่สามารถทราบได้ว่าผู้ใดเสียชีวิตก่อนกัน <mark className=" bg-[#fee9b2] rounded-xl">ดังนั้นจะไม่มีการรับมรดกซึ่งกันและกันระหว่างบุคคลทั้งสองนั้น โดยให้ปฏิบัติแก่บุคคลเหล่านั้นในเรื่องการรับมรดกเสมือนว่าเป็นบุคคภายนอกที่ไม่มีความสัมพันธ์ใด ๆ ต่อกัน</mark>{" "} ส่วนทายาทอื่น ๆ ของผู้ตายแต่ละคนก็จะได้รับมรดกของเขาไป 
            เพราะเงื่อนไขในการรับมรดกระบุไว้ว่า จะต้องมั่นใจว่าทายาทผู้รับมรดกมีชีวิตอยู่ภายหลังเจ้ามรดกเสียชีวิต
          </p>
        </div>{/* ผู้ตายหมู่ */}

        {/* ไม่มีทายาท */}
        <div>
          <h2 id="ninth-header">9. ผู้ตายที่ไม่มีทายาทในการรับมรดก (الكلالة)</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;กะลาละฮฺ (الكلالة) หมายถึง ผู้ตายที่ไม่มีทายาทในการรับมรดก ไม่ว่าจะเป็นทายาททางด้านสายเลือด และทายาทผู้ให้กำเนิด แต่มีผู้ที่มีสิทธิในการรับมรดกของเขาได้แก่ พี่น้องชาย-หญิงร่วมบิดามารดา หรือพี่น้องชาย-หญิงพ่อ หรือแม่เดียวกัน หรือลูกพี่ลูกน้อง เป็นต้น
          </p>
        </div>
      </div> {/* end of content */}
      

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
        <li>
            <a className="text-indigo-700 underline" href="/islam/1">
            ความรู้ทั่วไปของกฎหมายมรดกอิสลาม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/2">
              ทายาทที่มีสิทธิและเสียสิทธิรับมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/3">
            วิธีการคำนวณมรดกอิสลาม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/5">
              บทบัญญัติที่ถูกกล่าวถึงในกฎหมายมรดก
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/islam/6">
              พินัยกรรม
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default กรณีพิเศษ;
